import React from "react";

const RightArrowIcon = ({
  className = "",
  width = "6",
  height = "10",
  color = "black",
  restProps,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...restProps}
    >
      <path
        d="M0.418713 9.29766C0.335878 9.29764 0.254908 9.27716 0.186044 9.23879C0.117181 9.20043 0.0635161 9.14591 0.0318369 9.08212C0.000157703 9.01834 -0.00811283 8.94817 0.00807135 8.88047C0.0242555 8.81277 0.0641673 8.75059 0.122759 8.70179L4.98896 4.64663L0.122759 0.591457C0.0464711 0.525635 0.00425808 0.437476 0.00521228 0.345969C0.00616649 0.254462 0.0502116 0.166928 0.127861 0.10222C0.20551 0.0375125 0.310551 0.000808365 0.42036 1.31932e-05C0.530168 -0.000781979 0.635959 0.0343954 0.714946 0.0979689L5.87738 4.4C5.95589 4.46544 6 4.5542 6 4.64674C6 4.73928 5.95589 4.82804 5.87738 4.89349L0.714946 9.19551C0.676037 9.22792 0.62985 9.25362 0.579022 9.27114C0.528193 9.28867 0.47372 9.29768 0.418713 9.29766Z"
        fill={color}
      />
    </svg>
  );
};

export default RightArrowIcon;
